import templateUrl from './work-order-detail-modal.component.html';
import { IComponentOptions } from "angular";

export const WorkOrderDetailModalComponent: IComponentOptions = {
    templateUrl,
    bindings: {
        resolve: "<",
        dismiss: "&",
        close: "&"
    }
};

export const WorkOrderDetailModal = {
    component: "apexWorkOrderDetailModal",
    backdrop: "static",
    size: "md",
    windowClass: "xx-dialog pagespinner"
};
